import React from 'react';
import { useDispatch } from 'react-redux';

import { setIsDictionaryOnly } from '../../actions/rldToolActions';
import { RLD_IS_DICTIONARY_ONLY_LABEL } from './RldConstant';

const RldDictionaryOnly = () => {
  const dispatch = useDispatch();

  const handleStatusChange = event => {
    dispatch(setIsDictionaryOnly(event.target.checked));
  };

  return (
    <div className="rldDictionaryOnlyWrapper">
      <input
        type="checkbox"
        name="dictionaryOnly"
        id="dictionaryOnly"
        onChange={handleStatusChange}
      />
      <label htmlFor="dictionaryOnly">
        <span>{RLD_IS_DICTIONARY_ONLY_LABEL}</span>
      </label>
    </div>
  );
};
export default RldDictionaryOnly;
